import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import * as React from 'react';
import ContentLoader from 'react-content-loader';
import { Img } from 'react-image';
import { useLocalization } from '@/hooks/useLocalization';
import { Link } from '@/i18n/routing';
import OverlayBanner from './OverlayBanner';

export interface IProps {
  product: SearchProduct;
  wishListButton: boolean;
  isShowOnly?: boolean;
  hideOverlay?: boolean;
  maxHeight?: number;
  className?: string;
}

const ProductItemThumb: React.FC<IProps> = (props) => {
  const { product, wishListButton, isShowOnly } = props;
  const { deliveryType } = useLocalization();

  const Image = (
    <Img
      className="m-auto"
      style={{
        maxHeight: props.maxHeight ? `${props.maxHeight}px` : '300px',
        width: 'auto',
      }}
      src={[product.imageUrl!]}
      alt={product.name}
      loader={
        <ContentLoader
          uniqueKey="ProductItemThumbLoader"
          viewBox="0 0 1000 1000"
          speed={1}
          title=""
          backgroundColor="#f3f3f3"
          foregroundColor="#c3c3c3"
        >
          <path
            d="M510.765,967.015c0,0,12.123,2.202,70.529-3.306s53.996-30.857,53.996-30.857s-0.046-247.945,0-332.796
        c0.077-148.231-65.019-206.072-77.138-297.536c-13.046-98.458-9.918-199.459-9.918-199.459c10.744-16.253,0.549-33.61,0.549-33.61
        s0.771-10.207-4.959-14.876c-7.438-6.062-41.047-7.49-41.047-7.49s-37.744-0.05-42.702,9.693
        c-5.829,11.453-3.306,15.429-3.306,15.429s-8.815,13.774,0.368,31.957c0,0,6.01,91.464-4.342,197.254
        s-76.471,146.562-76.471,297.534c0,150.973,0,330.594,0,330.594s2.207,30.629,58.406,34.6S510.765,967.015,510.765,967.015z"
          />
        </ContentLoader>
      }
    />
  );

  return (
    <div className={`block w-full mb-3 relative ${props.className}`}>
      {wishListButton && !isShowOnly && (
        <div className="absolute inline-block top-[-10px] left-[-20px]">
          {/* <WishListButton product={product} /> */}
        </div>
      )}
      {!isShowOnly ? (
        <Link href={{ pathname: '/shop/[id]', params: { id: product.slug! } }}>
          {Image}
        </Link>
      ) : (
        Image
      )}

      {(deliveryType !== 'ecommerce' || !props.hideOverlay) && (
        <OverlayBanner product={product} />
      )}
    </div>
  );
};

export default ProductItemThumb;
